<template>
  <div
    class="layout layout--dashboard"
    :class="{ 'layout--has-sidebar': menu }"
  >
    <side-nav v-if="menu" :items="menu" />
    <app-header :fixed="fixedHeader" />
    <slot name="alert"></slot>
    <div
      role="main"
      class="layout__content"
      :class="{ 'layout__content--fluid': fluid }"
    >
      <div class="darken" v-if="darken"></div>
      <slot />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/app/AppHeader';
import SideNav from '@/components/app/SideNav';
import { mapState } from 'vuex';

export default {
  name: 'dashboard-layout',
  props: {
    fluid: {
      type: Boolean,
      required: false,
      default: true,
    },
    menu: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      fixedHeader: true,
    };
  },
  components: {
    AppHeader,
    SideNav,
  },
  computed: {
    ...mapState('ui', {
      darken: state => state.darken,
    }),
  },
};
</script>

<style lang="scss">
.layout {
  &--dashboard {
    flex-direction: column;
    background-color: color('background', 'light');
    color: color('text');
  }

  &--has-sidebar {
    padding-left: 50px;
  }

  &__container {
    display: flex;
    height: 100%;
  }

  &__content {
    display: flex;
    flex: 1;
    margin: 0 auto;

    &--fluid {
      max-width: 100%;
      padding: 0;
    }
  }
}

.darken {
  position: fixed;
  top: 68px;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

@media screen and (min-width: 1024px) {
  .layout {
    &--has-sidebar {
      padding-left: 240px;
    }
  }
}
</style>
